export default __webpack_public_path__ + "static/media/022-fishing.08779ceb.svg";